import { render, staticRenderFns } from "./generateAi.vue?vue&type=template&id=62f72846&scoped=true"
import script from "./generateAi.vue?vue&type=script&lang=js"
export * from "./generateAi.vue?vue&type=script&lang=js"
import style0 from "./generateAi.vue?vue&type=style&index=0&id=62f72846&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f72846",
  null
  
)

export default component.exports